// import { useSelector } from "react-redux";


const AkshayaPatraParticipation = () => {
//   const OrgId = useSelector((state) => state.auth.org_id)
  // console.log(OrgId, 'org_id__________')
  
  return (
    <div className="iframe-div">
        <iframe src= {`https://iiplwork.retool.com/embedded/public/e8ab667e-f524-46b3-bd3a-4a2bf1b9b0a7`}
        className="iframe-style"></iframe>
    </div>
  )
};

export default AkshayaPatraParticipation;
